import React from "react";
import { ReactComponent as CheckIcon } from "assets/svgs/check-fill.svg";
import { ReactComponent as DollarIcon } from "assets/svgs/dollar-fill.svg";
import { ReactComponent as LightningIcon } from "assets/svgs/lightning-fill.svg";
import {
  Progress,
  ProgressBarContainer,
  ProgressHeader,
  ProgressTrack,
  SearchStatus,
  SegmentedControl,
  SegmentButton,
} from "./styles";
import { OwnProps, SearchOrder } from "./types";

const OptionIcon: React.FC<{ option: SearchOrder }> = ({ option }) => {
  if (option === "cheapest") return <DollarIcon aria-hidden="true" />;
  if (option === "best") return <CheckIcon aria-hidden="true" />;
  return <LightningIcon aria-hidden="true" />;
};

const options: Array<{ value: SearchOrder; label: string }> = [
  { value: "cheapest", label: "Mais barato" },
  { value: "best", label: "Melhor opção" },
  { value: "fastest", label: "Mais rápido" },
];

export const SearchOrderSelector: React.FC<{
  selectedOrder: SearchOrder;
  onOrderChange: (order: SearchOrder) => void;
}> = ({ selectedOrder, onOrderChange }) => (
  <SegmentedControl role="tablist" aria-label="Ordenar resultados da busca">
    {options.map((option) => (
      <SegmentButton
        key={option.value}
        type="button"
        role="tab"
        aria-selected={selectedOrder === option.value}
        isActive={selectedOrder === option.value}
        order={option.value}
        onClick={() => onOrderChange(option.value)}
      >
        <OptionIcon option={option.value} />
        {option.label}
      </SegmentButton>
    ))}
  </SegmentedControl>
);

const ProgressBar: React.FC<OwnProps> = ({
  currentProgress,
  isMobile,
  selectedOrder,
  onOrderChange,
}) => {
  const progress = Math.max(0, Math.min(100, currentProgress));

  return (
    <ProgressBarContainer isMobile={isMobile}>
      <ProgressHeader isMobile={isMobile}>
        <SearchStatus>
          {progress >= 100
            ? "Melhores preços encontrados!"
            : "Buscando os melhores preços"}
        </SearchStatus>
        {!isMobile && (
          <SearchOrderSelector
            selectedOrder={selectedOrder}
            onOrderChange={onOrderChange}
          />
        )}
      </ProgressHeader>
      <ProgressTrack>
        <Progress width={progress} />
      </ProgressTrack>
    </ProgressBarContainer>
  );
};

export default ProgressBar;
